module.exports = __webpack_public_path__ + "img/3.d7f78bc2.png";